export default __webpack_public_path__ + "static/media/badge-border-darkpurple.253b3dc9.png";